(function(){
  var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.buy').forEach(function(box){
    var plans = Array.prototype.slice.call(box.querySelectorAll('.plan'));
    var atc = box.querySelector('[data-atc]');
    var fId = box.querySelector('input[name=id]'), fPlan = box.querySelector('input[name=selling_plan]');
    plans.forEach(function(el){ el.addEventListener('click', function(){
      plans.forEach(function(p){ p.setAttribute('aria-checked', p === el ? 'true' : 'false'); });
      if(fId){ fId.value = el.dataset.variant || fId.value; } if(fPlan){ fPlan.value = el.dataset.sellingPlan || ''; }
      atc.textContent = el.dataset.cta;
      var s=document.getElementById('stick-s'); if(s){ s.textContent = el.dataset.cta.split('· ')[1] + ' · 12-week guarantee'; }
    }); });
  });
  var stick = document.getElementById('stick');
  var first = document.getElementById('buy1');
  var hero = document.querySelector('.lphero');
  var heroGone=false, buyVisible=false;
  function upd(){ stick.classList.toggle('on', heroGone && !buyVisible); }
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){ es.forEach(function(e){ heroGone = !e.isIntersecting && e.boundingClientRect.top < 0; }); upd(); }, {threshold: 0}).observe(hero);
    document.querySelectorAll('.buy').forEach(function(b){ new IntersectionObserver(function(es){ es.forEach(function(e){ b._vis = e.isIntersecting; }); buyVisible = Array.prototype.some.call(document.querySelectorAll('.buy'), function(x){ return x._vis; }); upd(); }, {threshold: 0}).observe(b); });
  }
  document.querySelectorAll('a[href="#buy1"]').forEach(function(a){ a.addEventListener('click', function(ev){ ev.preventDefault(); first.scrollIntoView({behavior: smooth?'smooth':'auto', block:'center'}); }); });
})();
